// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1d5NL","content":"LoadingAlert_content__PfkX2"};